/**
 * Enumeration of all the types of notifications that can be published on the existing notification message queue.
 */
export enum NotificationType {
    LINE_TOOL_REQUEST_CREATED = "LINE_TOOL_REQUEST_CREATED",
    LINE_TOOL_REQUEST_APPROVED = "LINE_TOOL_REQUEST_APPROVED",
    LINE_TOOL_REQUEST_START_APPROVE_PROOCESS = "LINE_TOOL_REQUEST_START_APPROVE_PROOCESS",
    LINE_TOOL_REQUEST_REJECTED = "LINE_TOOL_REQUEST_REJECTED",
    LINE_TOOL_REQUEST_PROCESSED = "LINE_TOOL_REQUEST_PROCESSED",
    LINE_TOOL_REQUEST_DELIVERED = "LINE_TOOL_REQUEST_DELIVERED",
    LINE_TOOL_REQUEST_LOAD = "LINE_TOOL_REQUEST_LOAD",
    LINE_TOOL_REQUEST_CANCELED = "LINE_TOOL_REQUEST_CANCELED",
    LINE_TOOL_RETURN_CREATED = "LINE_TOOL_RETURN_CREATED",
    LINE_TOOL_RETURN_DELIVERED = "LINE_TOOL_RETURN_DELIVERED",
    LINE_TOOL_RETURN_APPROVED = "LINE_TOOL_RETURN_APPROVED",
    LINE_TOOL_RETURN_CANCELED = "LINE_TOOL_RETURN_CANCELED",
    FACILITY_TOOL_REQUEST_CREATED = "FACILITY_TOOL_REQUEST_CREATED",
    FACILITY_TOOL_REQUEST_APPROVED = "FACILITY_TOOL_REQUEST_APPROVED",
    FACILITY_TOOL_REQUEST_START_APPROVE_PROCESS = "FACILITY_TOOL_REQUEST_START_APPROVE_PROCESS",
    FACILITY_TOOL_REQUEST_PROCESSED = "FACILITY_TOOL_REQUEST_PROCESSED",
    FACILITY_RETURN_TOOL_REQUEST_CREATED = "FACILITY_RETURN_TOOL_REQUEST_CREATED",
    FACILITY_RETURN_TOOL_REQUEST_APPROVED = "FACILITY_RETURN_TOOL_REQUEST_APPROVED",
    TOOL_RETURN_PROCESSED = "TOOL_RETURN_PROCESSED",
    NEW_TICKET = "NEW_TICKET",
    UPDATE_TICKET = "UPDATE_TICKET",
    STRAIN_TICKET_UPDATED = "STRAIN_TICKET_UPDATED"
}
